export enum Sexs {
  Male = 'Male',
  Female = 'Female',
  Unknown = 'Unknown'
}
export interface IMapCenter {
  lat: number;
  lng: number;
}


// WEBPACK FOOTER //
// ./src/share/types/common.ts